module.exports = __webpack_public_path__ + "static/media/windows-skyscraper-business-reflect-office-corpora-PGZWL9F-min.ea06bbb6.jpg";